export default "__VITE_ASSET__BgBXtTmb__"